const UPDATE_PASSWORD = "Actualización de contraseña";

const NUM_UPDATE_PASSWORD = 1;

export default {
  NUM_UPDATE_PASSWORD
};
